module.exports = __webpack_public_path__ + "media/flags/eh-818ebb21.svg";